/**
 * Types for FBO Main API endpoints
 * Base URL: env.apiUrl
 */

// Code Table Value Types
export const CodeTableValueType = {
  Id: 0,    // Use numeric ID field
  Code: 1   // Use string code field
} as const

export type CodeTableValueTypeEnum = typeof CodeTableValueType[keyof typeof CodeTableValueType]

// From /api/AtsFieldMapping/destination-fields endpoint
export interface AtsDestinationFieldInfo {
  FieldPath: string
  DisplayName: string
  CodeTable: {
    Name: string
    ValueType: number
  } | null
  IsCodeTableField: boolean
}

// From /api/AtsFieldMapping/mappings endpoint (after PascalCase → camelCase transformation)
export interface ValueMapping {
  sourceValue: string | number | boolean
  destinationValue: string | number | boolean | null
}

export interface FieldMapping {
  destinationField: string
  sourceField: string
  valueMappings?: ValueMapping[]
  /**
   * Reference to a shared value mapping set. When present the server materializes
   * valueMappings from the set on read and discards inline values on save.
   */
  valueMappingSetName?: string | null
  dataTypeConverter?: string | null
  defaultValueMapping?: string | number | null
}

// From /api/AtsFieldMapping/value-mapping-sets (after PascalCase → camelCase transformation)
export interface ValueMappingSet {
  name: string
  description?: string | null
  /** ATS reference data set (e.g. "job_categories") backing the source value dropdown */
  atsReferenceType?: string | null
  /** Which reference item property source values use: "name" (default) or "id" */
  atsReferenceValueField?: string | null
  /** FBO code table (e.g. "CodeJobCategory") backing the destination value dropdown */
  fboCodeTableName?: string | null
  fboCodeTableValueType?: number | null
  valueMappings: ValueMapping[]
}

export interface Entity {
  entityType: string
  name: string
  referenceId?: string
  fieldMappings: FieldMapping[]
}

export interface MappingConfig {
  atsEntityType: string
  atsSource: string
  entities: Entity[]
}
